var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-bottom",on:{"click":_vm.clickEvent}},[_c('button',{staticClass:"btn btn-info"},[_vm._v("\n        "+_vm._s(_vm.$t('Buttons.SavedData'))+"\n        ")])])}
var staticRenderFns = []

export { render, staticRenderFns }